import FooterImg from 'assets/images/footer-Img.svg';
import intl from 'react-intl-universal';

export const renderFooterSection = () => {
  return (
    <div className='grid grid-cols-2 gap-0 p-4'>
      {renderFooterLeftSection()}
      {renderFooterRightSection()}
    </div>
  );
};

const renderFooterLeftSection = () => {
  return (
    <div className='bg-mint-green rounded-l-lg'>
      <img src={FooterImg} alt='footerImg' />
    </div>
  );
};

const renderFooterRightSection = () => {
  return (
    <div className='bg-mint-green flex items-center rounded-r-lg'>
      <div className='mx-2'>
        <h1 className='font-bold text-xl w-3/5'>
          {intl.get('ADD_INSIGHT.DONT_SEE_INSIGHTS')}
        </h1>
        <p className='font-normal mt-2'>
          <a
            href='mailto:support@cognota.com'
            className='text-steel-blue no-underline'
          >
            {intl.get('ADD_INSIGHT.CONTACT_COGNOTA')}
          </a>{' '}
          <span>{intl.get('ADD_INSIGHT.TO_ASK_ABOUT_ADDING_INSIGHTS')}</span>
        </p>
      </div>
    </div>
  );
};
